const escapeRegex = (string) => string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');

export const getRegEx = (value: string): RegExp => {
  if (!value) return null;
  try {
    return new RegExp(`(${escapeRegex(value)})(.*)`, 'i');
  } catch (err) {
    console.error('getRegEx', err);
    return null;
  }
};
